import { Navigate, Outlet, createFileRoute } from '@tanstack/react-router';

import { AppSkeletonLoader } from '@/components/AppSkeletonLoader';
import { RequireEntitlements } from '@/components/Auth/RequireEntitlements';
import { RequireFeatureFlag } from '@/components/Auth/RequireFeatureFlag';
import { RequireGeneratedContext } from '@/components/Auth/RequireGeneratedContext';
import { NotFound404 } from '@/components/NotFound404';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { useUser } from '@/hooks/useUser';

export const Route = createFileRoute('/$organizationName/org-docs')({
  component: GatedOrgDocsLayout,
  notFoundComponent: () => <NotFound404 />,
});

// Org Docs is default-off and org-admin only. Orgs without the flag are sent
// to the org home (which picks Investigations, MCP Setup or Codebases), as if the
// feature didn't exist; org members in a flagged org get Forbidden. Org docs
// are generated context, so a LITE organization is sent home the same way
// whatever its flag says.
function GatedOrgDocsLayout() {
  const { routeOrganizationName } = useUser();

  return (
    <RequireFeatureFlag
      flag={FEATURE_FLAGS.ORG_DOCS}
      loading={<AppSkeletonLoader />}
      redirect={<Navigate to="/$organizationName" replace params={{ organizationName: routeOrganizationName }} />}
    >
      <RequireGeneratedContext>
        <RequireEntitlements admins={['isSuperAdmin']}>
          <Outlet />
        </RequireEntitlements>
      </RequireGeneratedContext>
    </RequireFeatureFlag>
  );
}
